// extracted by mini-css-extract-plugin
module.exports = {"levelGroupWrapper":"WeakStreakLevels_levelGroupWrapper__1ODL1","icon":"WeakStreakLevels_icon__2owsy","levelTextWrapper":"WeakStreakLevels_levelTextWrapper__2Lj07"};